import { render, staticRenderFns } from "./staffAdd.vue?vue&type=template&id=5e7be538&scoped=true"
import script from "./staffAdd.vue?vue&type=script&lang=js"
export * from "./staffAdd.vue?vue&type=script&lang=js"
import style0 from "./staffAdd.vue?vue&type=style&index=0&id=5e7be538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7be538",
  null
  
)

export default component.exports